// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__On0HQ","modalBody":"StaffClientsModal_modalBody__KTMPj","formControl":"StaffClientsModal_formControl__7zRTC"};